import {
  WhatsappIcon,
  EmailIcon,
} from "react-share";
import { useEffect, useMemo, useState } from "react";
import useStore from "../../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../Button/Button.js";
import "./CharacterCard.css";
import close from "../../assets/img/Close.svg";

const CharacterCard = ({ role, active }) => {
  const [showShare, setShowShare] = useState(false);

  const getLocalized = useStore((state) => state.getLocalized);
  const uid = useStore((state) => state.uid);
  const url = useStore((state) => state.url);
  const checkinCharacter = useStore((state) => state.checkinCharacter);
  const sessionData = useStore((state) => state.sessionData);
  const checkRole = useStore((state) => state.checkRole);
  const gameState = useStore((state) => state.gameState);
  const game = useStore((state) => state.game);
  const [roleTaken, setRoleTaken] = useState(false);

  const defaultRole = useMemo(() => {
    console.log("Role", role);
    if (role.locale === "de") return role;
    else return role.localizations.find((l) => l.locale === "de");
  }, [role]);

  useEffect(() => {
    console.log("Session Data", sessionData);

    if (!role) return;
    console.log("RoleToCheck", role);
    const taken = checkRole(role);

    if (taken !== roleTaken) {
      setShowShare(false);
      setRoleTaken(taken);
    }
  }, [sessionData]);

  const getShareUrl = () => `${url}/character/?uid=${uid}&c=${defaultRole.uid}`;

  const getShareText = () => {
    const shareUrl = getShareUrl();
    return getLocalized("texts", "ShareText")
      ?.replace("%GAME%", game?.Name || "")
      .replace("%LINK%", shareUrl);
  };

  const handleWhatsappShare = () => {
    const text = encodeURIComponent(getShareText());
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  const handleEmailShare = () => {
    const subject = encodeURIComponent(getLocalized("texts", "ShareTitle") || "");
    const body = encodeURIComponent(getShareText());

    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <div
      className={`CharacterCard${showShare ? " showShare" : ""}${
        active ? " active" : ""
      }`}
    >
      <h3>{role.Name}</h3>

      {role?.Profilbild?.data?.attributes?.url && (
        <>
          <br />
          <img
            src={
              process.env.REACT_APP_CMS_URL +
              role.Profilbild.data.attributes.url
            }
            alt={role.Name}
          />
        </>
      )}
      <p>
        <b>{role.Subline}</b>
      </p>
      {!role.Hauptcharakter && (
        <p className="hint">{getLocalized("texts", "CharakterOptional")}</p>
      )}
      {role?.Introduction && <BlocksRenderer content={role?.Introduction} />}
      {!showShare && (
        <Button
          className={`full takeRole ${roleTaken ? "inActive" : ""}`}
          onClick={() => setShowShare(true)} //(gameState === -1 ? setShowShare(true) : null)}
        >
          {roleTaken
            ? getLocalized("texts", "RolleSchonVergeben")
            : getLocalized("texts", "RolleVergeben")}
        </Button>
      )}
      {showShare && (
        <div className="Share">
          <div onClick={handleWhatsappShare} style={{ cursor: "pointer", display: "inline-block" }}>
            <WhatsappIcon size={40} round={true} />
          </div>
          <div onClick={handleEmailShare} style={{ cursor: "pointer", display: "inline-block" }}>
            <EmailIcon size={40} round={true} />
          </div>

          <Button
            className="takeRole small"
            onClick={() => checkinCharacter(defaultRole, !roleTaken, true)}
          >
            {roleTaken
              ? getLocalized("texts", "RolleFreigeben")
              : getLocalized("texts", "SelbstAnnehmen")}
          </Button>

          <div className="close">
            <img src={close} onClick={() => setShowShare(false)} />
          </div>
        </div>
      )}
    </div>
  );
};
export default CharacterCard;
